import React from "react";
import styles from "./TalentTypeTag.module.css";

const TYPE_ALIASES = {
  internal: "internal",
  marketplace: "marketplace",
  pmt: "marketplace",
  external: "external",
};

const TYPE_LABELS = {
  internal: "Internal",
  marketplace: "PMT",
  external: "External",
};

const SIZE_CLASS = {
  sm: styles.sizeSm,
  md: styles.sizeMd,
};

const TalentTypeTag = ({ type, size = "sm", className = "" }) => {
  const normalizedType =
    TYPE_ALIASES[String(type || "").toLowerCase()] || "external";
  const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.sm;

  return (
    <span
      className={`${styles.tag} ${sizeClass} ${styles[normalizedType]} ${className}`.trim()}
    >
      {TYPE_LABELS[normalizedType]}
    </span>
  );
};

export default TalentTypeTag;
